/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import IntegrationsbutterflyLabsButterflyLabsIntegration from './IntegrationsbutterflyLabsButterflyLabsIntegration';

/**
 * The IntegrationsButterflyLabsBody model module.
 * @module model/IntegrationsButterflyLabsBody
 * @version v0.3
 */
export default class IntegrationsButterflyLabsBody {
  /**
   * Constructs a new <code>IntegrationsButterflyLabsBody</code>.
   * @alias module:model/IntegrationsButterflyLabsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsButterflyLabsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsButterflyLabsBody} obj Optional instance to populate.
   * @return {module:model/IntegrationsButterflyLabsBody} The populated <code>IntegrationsButterflyLabsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsButterflyLabsBody();
      if (data.hasOwnProperty('butterfly_labs_integration'))
        obj.butterflyLabsIntegration = IntegrationsbutterflyLabsButterflyLabsIntegration.constructFromObject(data['butterfly_labs_integration']);
    }
    return obj;
  }
}

/**
 * @member {module:model/IntegrationsbutterflyLabsButterflyLabsIntegration} butterflyLabsIntegration
 */
IntegrationsButterflyLabsBody.prototype.butterflyLabsIntegration = undefined;

